import {
	faBuildingColumns as fasBuildingColumns,
	faClockRotateLeft as fasClockRotateLeft,
	faLocationDot as fasLocationDot,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FormApi } from "final-form";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { AbstractStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import type { CommonOptions, ProgressButtonState } from "@/shared/ui";
import { FormSelect, ProgressButton } from "@/shared/ui";

interface StepFields {
	bankBranchCounty: string;
	bankBranch: string;
}

interface Props extends AbstractStepProps {
	bankBranches: Record<string, Record<string, string>>;
	submitState: ProgressButtonState;
}

export class BranchSelect extends AbstractStep<StepFields, Props> {
	protected renderContent(values: StepFields, _form: FormApi<StepFields>): ReactNode {
		const { submitState } = this.props;
		const hasSelectedCounty = !!values.bankBranchCounty;

		return (
			<>
				<Card.Header>
					<Card.Title className="retail-text text-center">
						<div className="text-uppercase">
							<FontAwesomeIcon icon={fasClockRotateLeft} className="mr-2" />
							Gyorsítsd az ügyintézést!
						</div>
						<div>
							Az alábbi adatok megadásával <br />
							<strong>felére csökkentheted</strong> a számlanyitási időt
						</div>
					</Card.Title>
				</Card.Header>
				<Card.Body className="flex-column align-items-start justify-content-start">
					<FormSelect
						label="Hol szeretnéd személyes ügyeidet intézni?"
						name="bankBranchCounty"
						placeholder="Válassz egy lehetőséget!"
						options={this.getBranchCountyList()}
						prepend={<FontAwesomeIcon icon={fasLocationDot} />}
						required
					/>
					<FormSelect
						label="Hol szeretnéd személyes ügyeidet intézni?"
						name="bankBranch"
						placeholder="Válassz egy lehetőséget!"
						options={this.getBranchList(values.bankBranchCounty)}
						disabled={!hasSelectedCounty}
						prepend={<FontAwesomeIcon icon={fasBuildingColumns} />}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton variant="gold" type="submit" size="lg" state={submitState}>
						Tovább
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	private getBranchCountyList(): CommonOptions {
		const { bankBranches } = this.props;

		return Object.keys(bankBranches).map((regio) => ({ label: regio, value: regio }));
	}

	private getBranchList(county: string): CommonOptions {
		const { bankBranches } = this.props;

		if (!county) {
			return [];
		}

		return Object.entries(bankBranches[county]).map((item) => ({ value: item[1], label: item[0] }));
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success"]).join(" ");
	}

	protected getComponentName(): string {
		return "BranchSelect";
	}
}
